import { render } from "./Colaborador.vue?vue&type=template&id=5665d59c&scoped=true"
import script from "./Colaborador.vue?vue&type=script&lang=js"
export * from "./Colaborador.vue?vue&type=script&lang=js"

import "./Colaborador.vue?vue&type=style&index=0&id=5665d59c&lang=css"
import "./Colaborador.vue?vue&type=style&index=1&id=5665d59c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5665d59c"]])

export default __exports__